import { makeVar } from '@apollo/client'

import { GetDebitCardsList_getDebitCardsV2_cards as DebitCard } from 'types/gql-types/GetDebitCardsList'

export const rvSelectedCard = makeVar<DebitCard | null>(null)
